// extracted by mini-css-extract-plugin
module.exports = {"bottombar":"_2b4B6","command":"_1j53S"};